module.exports = __webpack_public_path__ + "img/MemeETC (14).ded8e600.jpeg";